var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cga-modal" }, [
    _c("div", { staticClass: "modal-inner" }, [
      _c("div", { staticClass: "modal-content" }, [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "cga-status" },
              [
                _c("b-icon", {
                  attrs: { icon: "spinner", "custom-class": "fa-spin" }
                }),
                _c("span", [_vm._v(_vm._s(_vm.$t("cgu.loading")))])
              ],
              1
            )
          : _vm.loadError
          ? _c("div", { staticClass: "cga-status" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("cgu.error")) + "\n      ")
            ])
          : _vm._e(),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.loading && !_vm.loadError,
                expression: "!loading && !loadError"
              }
            ],
            staticClass: "pdf-container"
          },
          [_c("canvas", { ref: "pdfCanvas" })]
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading && !_vm.loadError,
              expression: "!loading && !loadError"
            }
          ],
          staticClass: "controls"
        },
        [
          _c(
            "button",
            {
              attrs: { disabled: _vm.pageNum <= 1 },
              on: { click: _vm.prevPage }
            },
            [_vm._v(_vm._s(_vm.$t("cgu.previous")))]
          ),
          _c("span", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("cgu.page", {
                    current: _vm.pageNum,
                    total: _vm.numPages
                  })
                ) +
                " "
            )
          ]),
          _c(
            "button",
            {
              attrs: { disabled: _vm.pageNum >= _vm.numPages },
              on: { click: _vm.nextPage }
            },
            [_vm._v(_vm._s(_vm.$t("cgu.next")))]
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "controls" },
        [
          _c(
            "b-button",
            {
              attrs: { disabled: _vm.loading || _vm.loadError },
              on: { click: _vm.accepteCGA }
            },
            [_vm._v("\n        " + _vm._s(_vm.$t("cgu.accepter")) + "\n      ")]
          ),
          _c("b-button", { on: { click: _vm.refuserCGA } }, [
            _vm._v("\n        " + _vm._s(_vm.$t("cgu.refuser")) + "\n      ")
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }